import { FC, useEffect, useState } from "react";

interface Iprops {
  imageUrl: any;
  closeImage: () => void;
}
const FullImage: FC<Iprops> = ({ imageUrl, closeImage }) => {
  const [cursorPosition, setCursorPosition] = useState({ top: 0 });

  useEffect(() => {
    document.querySelector("body")?.classList.add("body-without-overflow");
  }, []);
  const onMouseMove = (e: any) => {
    const img = document.getElementById("full_image_id");
    if (!!img && e.screenY + window.innerHeight <= img?.offsetHeight) {
      setCursorPosition({ top: -e.screenY });
    }
  };
  return (
    <div
      onMouseMove={onMouseMove}
      style={{
        position: "fixed",
        zIndex: 99999,
        right: "0",
        left: "0",
        top: "0",
        bottom: "0",
        objectFit: "cover",
        objectPosition: "100% 0",
      }}
    >
      <img
        id="full_image_id"
        alt="image Alt and Title"
        src={imageUrl}
        style={{
          ...cursorPosition,
          position: "relative",
          width: "100%",
          height: "auto",
          cursor:
            `url(${process.env.PUBLIC_URL + "/images/close-cursor.png"})` +
            ", auto",
        }}
        onClick={() => {
          document
            .querySelector("body")
            ?.classList.remove("body-without-overflow");
          closeImage();
        }}
      />
    </div>
  );
};

export default FullImage;
